import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './SPSCommerce.frontend.types'

@Injectable({ providedIn: 'root' })
export class SPSCommerce_get_completed_ordersService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { shipped_date: string, order_types?: string[], projects?: string[], has_transmission: boolean }): Promise<{ messages?: any[], orders?: { order_id?: number, order_lookup?: string, order_status?: string, shipment_id?: number, project_id?: number, project_lookup?: string, shipped_date?: string, modified_date?: string, transaction_id?: string }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.shipped_date)) {
      $missingRequiredInParams.push('\'shipped_date\'');
    }
    if (isNil($inParams.has_transmission)) {
      $missingRequiredInParams.push('\'has_transmission\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/Get/CompletedOrders`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

